import React, {useState } from 'react'
import templateIcon from './tempsnip.jpg'
import { Link } from 'react-router-dom'
import UserPic from './components/UserPic'
import SignUpBtn from './components/SignUpBtn'
import { withRouter } from 'react-router-dom'
// import SearchBar from '../SearchBar/SearchBar';
import LoginBtn from './components/LoginBtn';
import { useSelector } from 'react-redux'
import codeyolo from '../../assets/img/codeyolo.png'


const NavBar = () => {

  const { is_logged_in, is_loading } = useSelector(state => state.authReducer)

  const [state, setState] = useState({
    togglePenWindow: false,
    showYourProfile: false,
    id: '',
    user: '',
    search: false
  })

  const toggleNav = () => {
    setState({
      showNav: !state.showNav
    })
  }



  const postPen = () => {
    window.location.hash = "#/editor"
    toggleNav()
  }

return (
      <div className='Nav'>
        <nav className='nav1'>

          <div className='Name flex flex-row mb-8'>
            <Link to='/' className='link'><h1 className='Name-footer text-6xl'>
              {/* C <img className='icon-footer' src='http://blog.codepen.io/wp-content/uploads/2012/06/Button-White-Large.png' alt='' />  D Y O L O */}
              <img className='icon-footer mt-3' src={codeyolo} style={{
                width : 150,
                height : 180
              }} alt="Icon" />
              </h1></Link>
          </div>
          {is_logged_in && (
            <Link to="/profile" className="link">
              <div className='divProf'>
                <p className='Your'>YOUR</p>
                <h1 className='Prof'>Profile</h1>
                <div className='h-line'></div>
              </div>
            </Link>
          )}

          <Link to="/pens" className="link">
            <div className='divExp'>
              <h1 className='Exp'>EXPLORE</h1>
              <h1 className='Prof'>Pens</h1>
              <div className='p-line'></div>
            </div>
          </Link>

          {/* <Link to='/about' className='link'>
            <div className='divColl'>
              <h1 className='Coll'>About</h1>
              <div className='coll-line'></div>
            </div>
          </Link> */}

          <div className='nav2'>
            <div className='create' onClick={() => toggleNav()}>
              <h1>Create</h1>
              <img className='arrow' 
              src="https://static.wixstatic.com/media/0a9ac5_ada821b214df43feabfc80e16eebcbdb~mv2.gif" alt="arrow" />
            </div>

            {/* <Link to="/search">
              <button className='divMag'>
                <img className='mag' 
                src="https://cdn3.iconfinder.com/data/icons/basic-interface/100/search-512.png"
                alt="magnifier" />
              </button>
            </Link> */}
            { !is_logged_in && !is_loading && <LoginBtn />} 

            {
              !is_loading && <div>
                <div>
                  {is_logged_in ? <UserPic /> : <SignUpBtn />}
                </div>
              </div>
            }
          </div>

          <div className={state.showNav ? `show-nav createWin ${is_logged_in ? 'right-100' : 'right-150'}` : 'show-nav'} onClick={() => toggleNav()}>
            <div className='createWindow'>
              <h2 className='newPen' onClick={() => postPen()}> <img className='icon1' src={templateIcon} alt="" /> New Pen</h2>
            </div>
          </div>
        </nav>
      </div>
    )
  }

export default withRouter(NavBar)


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js